import { List, Modal, Tooltip, Typography } from 'antd';
import { MapMarker, PhoneOutline, UserOutline } from 'assets';

import img from '../../assets/images/logo.png';
import React, { useEffect, useState } from 'react';
import { requestform } from 'messages';
import { FollowingRequestDto } from '../../types/dto/following-request';
import { GetFollowingRequestList } from '../../hooks';
import FollowingRequestDetail from './FollowingRequestDetail';
import dayjs from 'dayjs';

interface TicketsProps {
  status: string;
  requestData: FollowingRequestDto;
  refreshData: () => void;
}

const FollowingRequestList: React.FC<TicketsProps> = ({ status, requestData, refreshData }) => {
  const { followingList: data, refetch, isLoading } = GetFollowingRequestList({ ...requestData, endPoint: status });

  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [openTicket, setOpenTicket] = useState<number>();

  const openDetailModal = (id: number) => {
    setOpenTicket(id);
    setDetailModalOpen(true);
  };
  const cancelDetailModal = () => {
    setDetailModalOpen(false);
  };
  useEffect(() => {
    if (!detailModalOpen) {
      refetch();
      refreshData();
    }
  }, [detailModalOpen, requestData]);

  const statusColors: Record<string, string> = {
    complaint: 'border-[#02D8A0]',
    electrical_safety: 'border-[#FF4D4F]',
    vip_customer: 'border-[#1890FF]',
    outage_entire_area: 'border-[#722ED1]',
    not_on_time: 'border-[#13C2C2]'
  };
  const borderColor = statusColors[status] || '';

  return (
    <div className='relative h-fit w-full'>
      <List
        loading={isLoading}
        className='list-item-hover-animation list-item-hover list-item-px-0-py-4 h-[70vh] overflow-y-auto'
        itemLayout='vertical'
        size='large'
        dataSource={data}
        renderItem={(item, index) => (
          <List.Item
            onClick={() => openDetailModal(item?.ticketId)}
            className='flex items-center justify-between'
            key={item?.ticketId}
          >
            <div key={index} className='flex justify-start space-x-4 align-middle'>
              <div className='my-auto flex w-[55px] space-x-2'>
                <Typography.Text className='font-oswald text-[14px]/[18px] text-[#141414]'>
                  {index + 1 + requestData.pageSize * (requestData.pageIndex - 1)}.
                </Typography.Text>
              </div>

              <div className='my-auto min-w-[75px]'>
                <Typography.Text className='font-oswald text-[22px]/[26px] leading-[1.1] text-[#141414]'>
                  {dayjs(item?.createdAt).format('HH:mm')}
                </Typography.Text>
                <br />
                <Typography.Text className='my-auto font-oswald text-[12px]/[16px] text-[#868D97]'>
                  {dayjs(item?.createdAt).format('DD/MM/YYYY')}
                </Typography.Text>
              </div>

              {/* General Information */}
              <div className={`flex items-center border-l-[3px] pl-8 ${borderColor}`}>
                <div className='space-y-2'>
                  <div className='flex space-x-2'>
                    <Typography.Text className='my-auto text-[16px]/[20px] font-semibold text-[#1564E8]'>
                      {item?.ticketId}
                    </Typography.Text>
                    <Typography.Text className='my-auto align-middle text-[16px]/[20px] font-semibold text-[#181818]'>
                      {item?.serviceType?.name
                        ? item?.serviceType?.name.split(' ').slice(0, 20).join(' ') +
                          (item?.serviceType?.name.split(' ').length > 10 ? '...' : '')
                        : 'Không có thông tin'}
                    </Typography.Text>
                    {item?.serviceType?.isRequiredCmis ? (
                      <Typography.Text className='rounded-[3px] bg-[#D1131D] px-[6px] py-[2px] text-[#FFFFFF]'>
                        CMIS
                      </Typography.Text>
                    ) : (
                      ''
                    )}

                    {item?.cmisRequestId && (
                      <Typography.Text className='rounded-[3px] bg-[#D1131D] px-[6px] py-[2px] text-[#FFFFFF]'>
                        CMIS #{item?.cmisRequestId}
                      </Typography.Text>
                    )}

                    <Typography.Text
                      className={`text-[14px]/[18px] font-normal italic ${
                        item?.numOfRequests > 5
                          ? 'text-[#D1131D]'
                          : item?.numOfRequests > 3
                            ? 'text-[#FF9500]'
                            : 'text-[#6C737E]'
                      }`}
                    >
                      {requestform.numOfRequest} {item?.numOfRequests} {requestform.numContacts}
                    </Typography.Text>
                  </div>
                  <div className='flex h-4 space-x-2'>
                    <img className='h-4 w-4' src={img} alt='' />
                    <Typography.Text className='text-[14px]/[18px] text-[#4D5664]'>
                      {item?.customerCode}
                    </Typography.Text>
                    <Typography.Text className='relative bottom-3.5 text-2xl font-bold'>.</Typography.Text>
                    <UserOutline />
                    <Typography.Text className='top-1 text-[14px]/[18px] text-[#4D5664]'>
                      <Tooltip title={item?.customerRequestName || ''}>
                        {item?.customerRequestName
                          ? item?.customerRequestName.split(' ').slice(0, 10).join(' ') +
                            (item?.customerRequestName.split(' ').length > 10 ? '...' : '')
                          : ''}
                      </Tooltip>
                    </Typography.Text>
                    <Typography.Text className='relative bottom-3.5 text-2xl font-bold'>.</Typography.Text>
                    <Typography.Text>
                      <PhoneOutline />
                    </Typography.Text>
                    <Typography.Text className='top-1 text-[14px]/[18px] text-[#4D5664]'>
                      {item?.customerRequestPhoneNumber}
                    </Typography.Text>
                    <Typography.Text className='relative bottom-3.5 text-2xl font-bold'>.</Typography.Text>
                    <Typography.Text>
                      <MapMarker />
                    </Typography.Text>
                    <Typography.Text className='top-1 text-[14px]/[18px] text-[#4D5664]'>
                      <Tooltip title={item?.customerRequestAddress || ''}>
                        {item?.customerRequestAddress
                          ? item?.customerRequestAddress.split(' ').slice(0, 10).join(' ') +
                            (item?.customerRequestAddress.split(' ').length > 10 ? '...' : '')
                          : ''}
                      </Tooltip>
                    </Typography.Text>
                  </div>
                  <div className='flex h-4 space-x-4'>
                    {item?.ticketDistributions?.find((ticketDistribution) => ticketDistribution.isPrimary === true)
                      ?.primaryTeamName && (
                      <div>
                        <Typography.Text className='relative text-[14px]/[18px] italic text-[#6C737E]'>
                          {requestform.responsibleOrganizationUnit}
                          {
                            item?.ticketDistributions?.find(
                              (ticketDistribution) => ticketDistribution.isPrimary === true
                            )?.primaryTeamName
                          }
                        </Typography.Text>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </List.Item>
        )}
      />

      {/* Detail Modal */}
      <Modal
        centered
        className='ant-modal-body-p-none h-[95vh] w-fit rounded-xl bg-[#F5F4F6]'
        open={detailModalOpen}
        onCancel={cancelDetailModal}
        footer={null}
        destroyOnClose
      >
        {openTicket && (
          <FollowingRequestDetail status={status} ticketId={openTicket} cancelDetailModal={cancelDetailModal} />
        )}
      </Modal>
    </div>
  );
};

export default FollowingRequestList;
